import { getEvents, getEventsByUser } from '@/store/thunks/events';
import { TEvent } from '@/types/events';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type TEventsState = {
    list: TEvent[]
    eventsByUsers: Record<number, TEvent[]>
    isLoading: boolean
    isLoaded: boolean
}

const initialState: TEventsState = {
    isLoading: false,
    isLoaded: false,
    eventsByUsers: {},
    list: [],
};

export const eventsSlice = createSlice({
    name: 'events',
    initialState,
    reducers: {
        setIsLoading: (state) => {
            state.isLoading = true;
            state.isLoaded = false;
        },
        setIsLoaded: (state) => {
            state.isLoading = false;
            state.isLoaded = true;
        },
    },
    extraReducers: builder => {
        builder.addCase(getEvents.pending, eventsSlice.caseReducers.setIsLoading);
        builder.addCase(getEvents.fulfilled, (state, action) => {
            state.list = action.payload;
            eventsSlice.caseReducers.setIsLoaded(state);
        });
        builder.addCase(getEvents.rejected, eventsSlice.caseReducers.setIsLoaded);

        builder.addCase(getEventsByUser.pending, eventsSlice.caseReducers.setIsLoading);
        builder.addCase(getEventsByUser.fulfilled, (state, action: PayloadAction<{ id: number, events: TEvent[] }>) => {
            state.eventsByUsers = {
                ...state.eventsByUsers,
                [action.payload.id]: action.payload.events,
            };
            eventsSlice.caseReducers.setIsLoaded(state);
        });
        builder.addCase(getEventsByUser.rejected, eventsSlice.caseReducers.setIsLoaded);
    },
});
